import { render, staticRenderFns } from "./RepairService.vue?vue&type=template&id=4174f94a"
import script from "./RepairService.vue?vue&type=script&lang=js"
export * from "./RepairService.vue?vue&type=script&lang=js"
import style0 from "./RepairService.vue?vue&type=style&index=0&id=4174f94a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports